import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import React from 'react';

export interface MicInputSelectorProps {
  readonly onDeviceChange: (device: MediaDeviceInfo) => void;
  readonly selectedDeviceId: string | undefined;
  readonly audioDevices: MediaDeviceInfo[];
  readonly disabled?: boolean;
}

export function MicInputSelector(props: MicInputSelectorProps) {
  const { onDeviceChange, selectedDeviceId, audioDevices, disabled } = props;

  const handleDeviceChange = (event: SelectChangeEvent<string>) => {
    let deviceId = event.target.value;
    let device = audioDevices?.find(x => x.deviceId === deviceId);
    device && onDeviceChange(device);
  };

  const menuItems = audioDevices.map(device => (
    <MenuItem key={device.deviceId} value={device.deviceId}>
      {device.label}
    </MenuItem>
  ));

  return (
    <FormControl variant="outlined" fullWidth style={{ marginBottom: 15 }} disabled={disabled}>
      <InputLabel id="sound-input-label">Lydinput</InputLabel>
      <Select labelId="sound-input-label" value={selectedDeviceId ?? 'Ingen'} onChange={e => handleDeviceChange(e)} label="Sound input">
        <MenuItem value="Ingen">
          <em>Ingen valgt</em>
        </MenuItem>
        {menuItems}
      </Select>
    </FormControl>
  );
}
